import {Component, forwardRef, ChangeDetectorRef, Injector} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FamocoScanLaserModel } from '../famoco-scan-laser.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { PlatformService } from 'src/app/core-api/platform/platform.service';

@Component({
    selector: 'abw-famoco-scan-laser-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FamocoScanLaserFormComponent),
        multi: true
      }
    ],
    templateUrl: './famoco-scan-laser-form.component.html',
    styleUrls: ['./famoco-scan-laser-form.component.scss']
})
export class FamocoScanLaserFormComponent extends AbstractWorkflowFormComponent<FamocoScanLaserModel, string> {
    constructor(
      private platformService: PlatformService,
      _workflowComponentsService: WorkflowComponentsService,
      _cdf: ChangeDetectorRef,
      _injector: Injector
	  ) {
        super(_workflowComponentsService, _cdf, _injector);
    }

    async scanCode() {
      try {
        console.log('Starting Famoco Scan Laser');
        const result = await this.platformService.famocoScanLaser();
        this.onValueChanged(result);
      } catch(e) {
        console.error(e);
      }
    }
}